import {Storage} from "./Storage";

export const apiFetch = async (url, data = {}) => fetch(url, {
    ...data,
    headers: {
        ...(data.headers || {}),
        'X-Auth-Token' : await Storage.getItem('token')
    }
})
